import { isBetsOpenStatusSelector } from '../../../store';
import type { CoreStoreType } from '../../../store/CoreStore';
import { betActions } from '../../../store/slices/bets/slice';
import { getAcceptedBets } from '../betUtilities/getAcceptedBets';
import { getComputedBets } from '../betUtilities/getComputedBets';
import type { ComputedBet } from '../betUtilities/types';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

declare global {
  interface Window {
    betStateBitMask?: number;
  }
}

export class GameCommunicationCommandProcessor implements IGameCommunicationProcessor {
  messageName = 'command';
  delay = 0;

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    const isBetsOpenStatus = isBetsOpenStatusSelector(store.getState());
    if (isBetsOpenStatus) {
      this.updateAcceptedBets(store, this.computeBets(store));
    }
  }

  protected computeBets(store: CoreStoreType): ComputedBet[] {
    const { bets } = store.getState();
    return getComputedBets(bets.betStack);
  }

  protected updateAcceptedBets(store: CoreStoreType, computedBets: ComputedBet[]): void {
    store.dispatch(betActions.setAcceptedBets(getAcceptedBets(computedBets)));
  }
}
